// extracted by mini-css-extract-plugin
module.exports = {"axisY":"HeatMapD3_axisY__3nqUA","axisLight":"HeatMapD3_axisLight__15CNS","axisDark":"HeatMapD3_axisDark__2QBlk"};